import { render, staticRenderFns } from "./tipsItem.vue?vue&type=template&id=7ef0b01a&scoped=true"
import script from "./tipsItem.vue?vue&type=script&lang=ts"
export * from "./tipsItem.vue?vue&type=script&lang=ts"
import style0 from "./tipsItem.vue?vue&type=style&index=0&id=7ef0b01a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef0b01a",
  null
  
)

export default component.exports